import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  title: 'Accede',
  desc: 'Realiza tu compra y recibe acceso inmediato al contenido digital.'
}, {
  title: 'Aprende',
  desc: 'Sigue la guía y las clases grabadas paso a paso, comenzando por las técnicas fundamentales.'
}, {
  title: 'Crea',
  desc: 'Elige una plantilla, prepara tus materiales y comienza a transformar lo aprendido en tus propios proyectos.'
}];
export function HowItWorks() {
  return <section className="bg-fil-bg px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-90" data-mp="lmmf10zuiaer">
      <div className="max-w-4xl mx-auto" data-id="element-91" data-mp="qiv2r2s3zbxj">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight text-center max-w-2xl mx-auto mb-10" data-id="element-92" data-mp="crydnlxe5cv8">
          Aprender filigrana puede ser mucho más sencillo de lo que parece
        </h2>

        <ol className="grid sm:grid-cols-3 gap-5 sm:gap-6" data-id="element-93" data-mp="14iw1ocotc9ad">
          {steps.map((step, i) => <motion.li key={step.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-fil-card rounded-[1.75rem] border border-fil-beige p-6 sm:p-8 flex flex-col items-center text-center" data-id="element-94" data-mp="199m8lucw0k76" data-mpi={i}>
              <span className="w-11 h-11 rounded-full bg-fil-terra text-white font-serif font-bold flex items-center justify-center mb-4" data-id="element-95" data-mp="2wjz8vqydf3ho">
                {i + 1}
              </span>
              <h3 className="text-lg font-bold text-fil-text uppercase tracking-wide mb-2" data-id="element-96" data-mp="369ircvi68vc0">
                {step.title}
              </h3>
              <p className="text-sm sm:text-base text-fil-text/70 leading-relaxed mt-auto" data-id="element-97" data-mp="3k890j9i9mlgq">
                {step.desc}
              </p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}